<app-tabla-general 
  [displayedColumns]="displayedColumns" 
  [moduloActual]="'usuarios'"
  (editarUsuario)="abrirModalEditar($event)">
</app-tabla-general>
<router-outlet></router-outlet>
<app-modal-editar-usuario 
  *ngIf="usuarioSeleccionado" 
  [usuario]="usuarioSeleccionado" 
  [unidadId]="unidadId"
  (cerrar)="cerrarModal()" 
  (usuarioActualizado)="onUsuarioActualizado()">
</app-modal-editar-usuario>
